import { NavigationApi } from '../../../../api/NavigationApi';
import { ottActionFilter } from '../../../../api/models/ActionFilter';
import { SearchApi } from '../../../../api/SearchApi';
import { AdultType, ExtraDataType } from '../../../../api/models/Shared.types';
import { SearchRowDataSource } from '../../../../Business/cms/search/SearchRowDataSource';
import { Log } from '@lightningjs/sdk';
import { ChannelManager } from '../../../../api/ChannelManager';

export class SearchPageDataSource {
  /**
   * @param {Backend} backend
   * @param menuItem
   */
  constructor(backend, menuItem) {
    this.backend = backend;
    this.menuItem = menuItem;
    /**
     * @type {ChannelModel[]}
     */
    this.channels = [];
  }

  init() {
    const customParam = {
      entitlementId: this.backend.sessionInfo.device.entitlementId,
      actionFilter: ottActionFilter,
      adult: false,
    };
    return NavigationApi.customPage(this.backend, this.menuItem.pageId, customParam)
      .then(page => {
        this.page = page;
        Log.info(page);
      })
      .catch(error => {
        Log.error(error);
      });
  }

  search(term) {
    const extraData = this.page.searchPage.properties.includes('HIDE_MINI_DETAIL')
      ? ExtraDataType.NONE
      : ExtraDataType.MINI;

    const requestParams = {
      searchTerm: term,
      adult: AdultType.False,
      catalogId: this.backend.deviceProfile.profile.catalog,
      extraData: extraData,
    };

    const searchProm = SearchApi.search(
      this.backend,
      requestParams.searchTerm,
      this.page.searchPage.rows.map(row => row.type),
      requestParams.adult,
      requestParams.catalogId,
      true,
      0,
      requestParams.extraData
    );

    const channelProm = ChannelManager.channels(this.backend);
    return Promise.all([searchProm, channelProm])
      .then(([searchRes, channels]) => {
        this.channels = channels;
        return { completions: searchRes.completions, rows: this.convert(searchRes, requestParams) };
      })
      .catch(err => {
        Log.error(err);
        return { completions: [], rows: [] };
      });
  }

  /**
   * @param {ISearchResponseV3} data
   */
  convert(data, requestParams) {
    let rows = data.results;
    const isGrid = rows.length === 1;

    return rows.map(row => new SearchRowDataSource(this.backend, this.page, row, isGrid, this.channels, requestParams));
  }

  logPageView() {
    this.backend.logService.trackPageView(this.menuItem.pageId, this.menuItem.title);
  }
}
